import CopyrightClaim from '@anm/components/user/YoutubeWhitelist/CopyrightClaim';
import { FC } from 'react';

import { useCopyrightClaimHandlers } from './hooks';

const CopyrightClaimWrapper: FC = () => {
  const [
    hasChannels,
    isPendingSubmit,
    handleSubmit
  ] = useCopyrightClaimHandlers();

  if (!hasChannels) return null;

  return <CopyrightClaim {...{ isPendingSubmit }} onSubmit={handleSubmit} />;
};

export default CopyrightClaimWrapper;
